import { g as getDateFromDatepicker } from './get-date-from-datepicker.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Bookerclub
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_127
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    // Hotel Torre del Marques(p1036679) has an SPA Homepage
    // We need to force the page_check to identify the booking iframe
    if (window.location.hostname.match(/www\.hoteltorredelmarques\.com/)) {
      thn.pageCheck();
    }
  };

  engine.priceObserveDom = function priceObserveDom(ctx) {

    const $ = window.jQuery;

    if (!$) { return; }

    const $rooms = $('#rooms');
    let canUpdate = false;

    if ($rooms.length && !thn.bookerclubLoader) { // still loading
      thn.bookerclubLoader = thn.debounce(() => {
        ctx.widget.logger.debug('*************** DOM Changed **************');
        if (canUpdate) {
          canUpdate = false;
          ctx.widget.update();
        }
      }, 800);

      thn.observeDom($rooms.get(0), thn.bookerclubLoader, {
        childList: true,
        subtree: false,
      });

      $('.buscarmask').click(() => { canUpdate = true; });

      thn.pageUnload(() => {
        $('.buscarmask').off('click');
        thn.stopObserveDom($rooms.get(0), thn.bookerclubLoader);
        delete thn.bookerclubLoader;
      });
    }

  };

  engine.priceParseData = function priceParseData(ctx) {

    var widgetData = {};
    var $ = window.jQuery;

    if (!$) {
      return widgetData;
    }

    if ($('#rooms').children().length) { // not loading

      widgetData.dateBegin = getDateFromDatepicker('#CheckInDateLabel');
      widgetData.dateEnd = getDateFromDatepicker('#CheckOutDateLabel');

      const rooms = parseInt($('#Rooms').val(), 10) || 1;
      let adultsSelector = '#Adults';
      let childrenSelector = '#Children';
      if (rooms > 1) {
        adultsSelector += '_1';
        childrenSelector += '_1';
      }
      widgetData.adults = parseInt($(adultsSelector).val(), 10) || 2;
      widgetData.children = parseInt($(childrenSelector).val(), 10) || 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      // NO AVAILABILITY
      if ($('.althoteltextdesc').length) {
        widgetData.noRooms = true;

      } else {
        const $prices = $('#rooms .tprice');
        const prices = $prices.filter(function (idx, el) {
          var $el = $(el),
            $capacity = $el.siblings('.tcapacidad'),
            roomAdults = $capacity.find('.person-adult').length,
            roomChildren = $capacity.find('.person-child').length,
            roomGuests = roomAdults + roomChildren;
          // when the room does specify some of its guests as children
          if (roomChildren) {
            // then guests must fit AND adults must fit, then children will fit also
            return widgetData.guests <= roomGuests && widgetData.adults <= roomAdults;
            // when the room doesn't specify children
          }
          // then just care about guests
          return widgetData.guests <= roomGuests;

        }).map(function (idx, el) {
          return thn.parseNumber($(el).find('.price').text());
        }).toArray();

        if (!prices.length) {

          widgetData.noRooms = true;

        } else {

          widgetData.price = Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
          widgetData.currency = thn.getCurrencyCode($prices.eq(0).text().match(/[^\d\s,.]+/)[0]);
          widgetData.set = true;
        }
      }

    } else if (window.location.hostname === 'secure.bookerclub.com' && window.location.pathname === '/cgi-bin/mobile/index.pl') { // mobile version https://secure.bookerclub.com/cgi-bin/mobile/index.pl

      widgetData.dateBegin = thn.dateToString(thn.parseUrlParameter('CheckInDate').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3'));
      widgetData.dateEnd = thn.dateToString(thn.parseUrlParameter('CheckOutDate').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3'));

      // the mobile engine doesn't display guest info
      widgetData.adults = 2;
      widgetData.children = 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      const pricesEls = document.querySelectorAll('.price');
      if (pricesEls.length > 0) {
        const prices = [...pricesEls].map(function (priceEl) {
          if (priceEl.childNodes.length) {
            return thn.parseNumber(priceEl.childNodes[priceEl.childNodes.length - 1].textContent);
          }
          return thn.parseNumber(priceEl.textContent);
        });
        widgetData.price = Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        widgetData.currency = thn.getCurrencyCode(pricesEls[0].textContent.match(/[^\d\s,.]+/)[0]);
        widgetData.set = true;
      } else {
        widgetData.noRooms = true;
      }
    }

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    var widgetData = {};
    var $ = window.jQuery;

    const getDatesFromAttribute = () => {
      const urlEl = document.querySelector('[src*="https://secure-hotel-tracker.com/"]')?.getAttribute('src');
      const params = urlEl && (new URL(urlEl)).searchParams;

      if (!params) { return {}; }

      return {
        dateBegin: params.get('checkin')?.replace(/-/g, '/').replace(/%/g, ''),
        dateEnd: params.get('checkout')?.replace(/-/g, '/').replace(/%/g, ''),
      };
    };

    if (window.location.hostname.match(/secure.bookerclub.com/) && window.location.pathname.match(/mobile/)) {
      const priceEl = document.querySelector('div.mhnm');
      if (priceEl) {
        widgetData.price = thn.parseNumber(priceEl.textContent);

        let currency = priceEl.textContent.split(':')[1] || '';
        currency = thn.getCurrencyCode((currency.match(/[^\d\s,.]+/) || [])[0]);
        widgetData.currency = currency;
      }
      const bookingIdEl = document.querySelector('.imagemap').nextElementSibling.nextSibling;
      if (bookingIdEl) {
        widgetData.bookingId = thn.parseNumber(bookingIdEl.textContent);
      }

      widgetData.dateBegin = getDatesFromAttribute().dateBegin || thn.widgets.price.data.dateBegin;
      widgetData.dateEnd = getDatesFromAttribute().dateEnd || thn.widgets.price.data.dateEnd;

    } else {
      let match;
      const price = $ && $('table.tableinstatusleftbg > tbody > tr:last-child > td:last-child').text().trim();

      widgetData.price = thn.dataLayerHelper.get('ecommerce.purchase.actionField.revenue');
      widgetData.currency = thn.dataLayerHelper.get('ecommerce.currencyCode')
                || thn.dataLayerHelper.get('ecommerce.purchase.actionField.currency');
      widgetData.bookingId = thn.dataLayerHelper.get('ecommerce.purchase.actionField.id');

      if (!widgetData.price) {
        match = document.body.textContent.match(/ga\(\s*'ecommerce:addTransaction'\s*,\s*{[^}]*\s*['"]revenue['"]\s*:\s*["']([^"']+)[^}]*}/);
        if (match && match.length === 2) {
          widgetData.price = match[1];
        }
        match = document.body.textContent.match(/ga\(\s*'ecommerce:addTransaction'\s*,\s*{[^}]*\s*['"]currency['"]\s*:\s*["']([^"']+)[^}]*}/);
        if (match && match.length === 2) {
          widgetData.currency = match[1];
        }
      }

      if (!widgetData.bookingId) {
        match = document.body.textContent.match(/ga\(\s*'ecommerce:addTransaction'\s*,\s*{[^}]*\s*['"]id['"]\s*:\s*["']([^"']+)[^}]*}/);
        if (match && match.length === 2) {
          widgetData.bookingId = match[1];
        }
      }

      if (!widgetData.price && price) {
        widgetData.price = thn.parseNumber(price);
        widgetData.currency = thn.getCurrencyCode(price.match(/[^\d\s,.]+/)[0]);
      }

      widgetData.dateBegin = translateDate($('div.statusleft > table:nth-child(2) > tbody > tr:nth-child(2) > td:last-child').text(), thn.data.language || 'en') || getDatesFromAttribute().dateBegin;
      widgetData.dateEnd = translateDate($('div.statusleft > table:nth-child(2) > tbody > tr:nth-child(3) > td:last-child').text(), thn.data.language || 'en') || getDatesFromAttribute().dateEnd;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
